export default function simpleLocation(location: Partial<guesthouse.Location>) {
  if (typeof location === 'string') {
    return location;
  }

  if (typeof location?.address === 'string') {
    return location.address.replace(', USA', '');
  }
}
